<template>
  <Wrapper :pageName="pageName">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="form-style">
      <el-form-item label="标题" prop="title">
        <el-input :disabled="['look', 'publish', 'publishLook'].includes(type)" maxlength="17" show-word-limit v-model="ruleForm.title" style="width: 400px;" placeholder="请输入标题"></el-input>
      </el-form-item>
      <el-form-item label="封面图片" prop="imgUrl">
        <div class="deal-img">
          <div>
            <el-upload
              ref="upload"
              :class="`avatar-uploader-${sourceType}`"
              :disabled="['look', 'publish', 'publishLook'].includes(type)"
              :action="action"
              :headers="headers"
              :data="{fileType: 'image', sourceType}"
              :auto-upload="false"
              :multiple="false"
              :on-change="handleChange"
              :show-file-list="false">
              <img v-if="ruleForm.imgUrl" :src="ruleForm.imgUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <p class="rate">推荐封面图片尺寸比例：{{ rate }}</p>
          </div>
          <div class="cropper-wrapper" v-if="type !== 'look'">
            <vueCropper
              ref="cropper"
              :img="cropperImg"
              :outputSize="1"
              :outputType="'jpeg'"
              autoCrop
              fixed
              :fixedNumber="fixedNumber"
            ></vueCropper>
            <el-button @click="startCrop" type="primary" style="margin-top: 20px;">裁剪并上传</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="内容图片" prop="contentImgUrl">
        <el-upload
          ref="upload"
          class="content-img"
          :disabled="['look', 'publish', 'publishLook'].includes(type)"
          :action="action"
          :headers="headers"
          :data="{fileType: 'image', sourceType}"
          :on-success="fileUpdateEvent"
          :multiple="false"
          :before-upload="beforeUpload"
          :show-file-list="false">
          <img v-if="ruleForm.contentImgUrl" :src="ruleForm.contentImgUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item v-if="sourceType === 2" label="文章摘要" prop="articleAbstract">
        <el-input type="textarea" :rows="4" :disabled="['look', 'publish', 'publishLook'].includes(type)" v-model="ruleForm.articleAbstract" maxlength="50" show-word-limit style="width: 700px;" placeholder="请输入文章摘要"></el-input>
      </el-form-item>
      <el-form-item label="正文内容" prop="bannerContent">
        <div style="height: 600px; width: 40%;"><Editor :disabled="['look', 'publish', 'publishLook'].includes(type)" :value="ruleForm.bannerContent" :sourceType="sourceType" @input="handleEditorChange" @uploadSuccess="handleUploadSuccess"/></div>
      </el-form-item>
      <el-form-item label="报名时间" prop="signUpTime" v-if="sourceType === 3">
        <el-date-picker
          v-model="ruleForm.signUpTime"
          :disabled="['look', 'publish', 'publishLook'].includes(type)"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm"
          style="width: 400px;"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="活动时间" prop="beginTime" v-if="sourceType === 3">
        <el-date-picker
          v-model="ruleForm.beginTime"
          :disabled="['look', 'publish', 'publishLook'].includes(type)"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm"
          style="width: 400px;"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="是否通知" prop="createNoticeType" v-if="sourceType === 3 && isApprove">
        <el-radio v-model="isNotice" :label="0" :disabled="['publishLook', 'look'].includes(type)">否</el-radio>
        <el-radio v-model="isNotice" :label="3" :disabled="['publishLook', 'look'].includes(type)">是</el-radio>
        <el-select v-model="ruleForm.createNoticeType" placeholder="请选择" :disabled="['publishLook', 'look'].includes(type)" v-if="isNotice === 3">
          <el-option
            v-for="item in vipTypes"
            :key="item.value" 
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始提醒" prop="startNoticeType" v-if="sourceType === 3 && isApprove">
        <el-radio v-model="isRemind" :label="0" :disabled="['publishLook', 'look'].includes(type)">否</el-radio>
        <el-radio v-model="isRemind" :label="1" :disabled="['publishLook', 'look'].includes(type)">是</el-radio>
        <el-checkbox-group v-model="ruleForm.startNoticeType" v-if="isRemind === 1">
          <el-checkbox :value="1" label="1" :disabled="['publishLook', 'look'].includes(type)">一天</el-checkbox>
          <el-checkbox :value="3" label="3" :disabled="['publishLook', 'look'].includes(type)">三天</el-checkbox>
          <el-checkbox :value="7" label="7" :disabled="['publishLook', 'look'].includes(type)">七天</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="发布时间" prop="publishTime" v-if="sourceType !== 3 && isApprove">
        <el-row>
          <el-col :span="2"><el-radio :disabled="['publishLook', 'look'].includes(type)" v-model="ifPublishNow" :label="0">自定义时间</el-radio></el-col>
          <el-col :offset="1" :span="12"><el-radio :disabled="['look'].includes(type)" v-model="ifPublishNow" :label="1">立即发布</el-radio></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-date-picker
              v-if="ifPublishNow === 0"
              v-model="ruleForm.publishTime"
              :disabled="['publishLook', 'look'].includes(type)"
              :picker-options="pickerOptions"
              start="09:00"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              style="width: 300px;"
              placeholder="选择发布日期时间">
            </el-date-picker>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
    <div class="operate-btns">
      <el-button plain class="ml30" @click="goBack">返回上一页</el-button>
      <el-button :type="isPreview?'primary':'plain'" class="ml30" @click="preView">预览</el-button>
      <el-button class="ml30" v-if="type !== 'look'" type="primary" @click="submitForm('ruleForm')">{{ submitText }}</el-button>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <AppPage v-if="isPreview" @closePrview="closePrview" :sourceType="sourceType" :ruleForm="ruleForm"/>
  </Wrapper>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { VueCropper } from 'vue-cropper'
import Wrapper from '@/components/page/Wrapper.vue'
import Editor from '@/components/Editor.vue'
import AppPage from './components/phonePage.vue'
import { saveConfigInfo, updateConfigInfo, getConentDetail, uploadImage, bannerOperate } from '@/api/configPage.js'
import { articleOperate } from '@/api/article'
import { activityOperate } from '@/api/activity'
const initParams = {
  title: '',
  publishTime: '',
  bannerContent: '',
  imgUrl: '',
  contentImgUrl: '',
  articleAbstract: '',
  signUpTime: [],
  beginTime: [],
  createNoticeType: 1, // 活动通知类型
  startNoticeType: [] // 活动开始提醒时间
}

export default {
  components: { Wrapper, Editor, AppPage, VueCropper },
  data () {
    const { sourceType = 0, id, type } = this.$route.query
    const action = process.env.VUE_APP_UPLOAD_API
    const Authorization = this.$cookie.get('Authorization')
    const imageCheck = (rule, value, callback) => {
      if (value) {
        callback()
      } else {
        callback(new Error('请上传图片'))
      }
    }
    const dateCheck = (rule, value, callback) => {
      if (value.length === 2) {
        callback()
      } else {
        callback(new Error('请选择时间'))
      }
    }
    const dataCheck2 = (rule, value, callback) => {
      if (this.ifPublishNow === 1) {
        callback()
        return false
      }

      const currentTime = moment().format('YYYY-MM-DD HH:mm')
      const publishTime = moment(value).format('YYYY-MM-DD HH:mm')
      console.log(currentTime, publishTime)
      if (currentTime > publishTime) {
        callback(new Error('发布时间要大于当前时间'))
      } else if (!value) {
        callback(new Error('请选择时间'))
      } else {
        callback()
      }
    }

    const titleCheck = (rule, value, callback) => {
      if (value.length > 20) {
        callback(new Error('不能超过20个字符'))
      } else {
        callback()
      }
    }
    const noticeFnc = (rule, value, callback) => {
      callback()
    }
    const remindFnc = (rule, value, callback) => {
      callback()
    }

    let detailUrl = ''
    let saveUrl = ''
    let updateUrl = ''
    let sourceKey = ''
    switch (+sourceType) {
      case 1:
        detailUrl = '/bannerInfo/detail'
        saveUrl = '/bannerInfo/save'
        updateUrl = '/bannerInfo/update'
        sourceKey = 'bannerContent'
        break
      case 2:
        detailUrl = '/articleInfo/detail'
        saveUrl = '/articleInfo/save'
        updateUrl = '/articleInfo/update'
        sourceKey = 'articleContent'
        break
      case 3:
        detailUrl = '/activity/activity_details'
        saveUrl = '/activity/create'
        updateUrl = '/activity/update'
        sourceKey = 'details'
        break

      default:
        break
    }
    let rules = {
      title: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          {validator: titleCheck, trigger: 'blur'}
      ],
      bannerContent: [
          { required: true, message: '请编辑内容', trigger: 'blur' }
      ],
      imgUrl: [
          { required: true, trigger: 'blur', validator: imageCheck }
      ],
      contentImgUrl: [
          { required: true, trigger: 'blur', validator: imageCheck }
      ],
      signUpTime: [
          { required: true, trigger: 'blur', validator: dateCheck }
      ],
      beginTime: [
          { required: true, trigger: 'blur', validator: dateCheck }
      ]
    }
    if (type === 'publish' || type === 'publishLook') { // 发布状态下，变为必填
      rules = {
        ...rules,
        publishTime: [
          { required: true, trigger: 'blur', validator: dataCheck2 }
        ],
        createNoticeType: [
          { required: true, trigger: 'blur', validator: noticeFnc }
        ],
        startNoticeType: [
          { required: true, trigger: 'blur', validator: remindFnc }
        ]
      }
    }
    return {
      noticeType: 1, // 通知群体
      isNotice: 0, // 是否通知
      isRemind: 0, // 是否提醒
      action,
      id,
      type,
      detailUrl,
      saveUrl,
      updateUrl,
      sourceKey,
      sourceType: +sourceType,
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      headers: { Authorization },
      ruleForm: {...initParams},
      ifPublishNow: 0,
      vipTypes: [{
        value: 1,
        label: '全部'
      }, {
        value: 2,
        label: '青藤'
      }],
      imgRate: [{
        sourceType: 1,
        suggestWidth: 75,
        suggestHeight: 36
      }, {
        sourceType: 2,
        suggestWidth: 56,
        suggestHeight: 20
      }, {
        sourceType: 3,
        suggestWidth: 75,
        suggestHeight: 32
      }],
      cropperImg: '',
      rules,
      fileUrls: [], // 富文本图片
      isPreview: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      }
    }
  },
  mounted () {
    if (this.id) {
      this.contentDetail() // 获取内容详情
    }
  },
  computed: {
    ...mapState({
      menuCodeSet: state => state.user.menuCodeSet
    }),
    rate () {
      const {suggestHeight, suggestWidth} = this.imgRate.find(item => item.sourceType === this.sourceType)
      return `${suggestWidth} / ${suggestHeight}`
    },
    fixedNumber () {
      const {suggestHeight, suggestWidth} = this.imgRate.find(item => item.sourceType === this.sourceType)
      return [suggestWidth, suggestHeight]
    },
    pageName () {
      if (this.sourceType === 1) {
        return 'banner配置页面'
      } else if (this.sourceType === 2) {
        return '文章配置页面'
      } else if (this.sourceType === 3) {
        return '活动配置页面'
      }
    },
    isApprove () { // 是否是运维权限
      let type = ''
      if (this.sourceType === 1) {
        type = 'bannerList'
      } else if (this.sourceType === 2) {
        type = 'articleList'
      } else if (this.sourceType === 3) {
        type = 'activityList'
      }
      return this.menuCodeSet.includes(type)
    },
    submitText () {
      if (this.type === 'publish') {
        return '发布'
      } else if (this.id) {
        return '保存编辑'
      } else {
        return '保存'
      }
    }
  },
  destroyed () {
    this.id = ''
    this.ruleForm = {...initParams}
  },
  watch: {
    ifPublishNow (type) {
      if (type === 1) {
        this.ruleForm.publishTime = ''
        this.$refs.ruleForm.clearValidate('publishTime')
      }
    },
    isNotice (val) {
      if (val === 3) {
        if (this.ruleForm.createNoticeType === 0) {
          this.ruleForm.createNoticeType = 1
        }
      }
    }
  },
  methods: {
    goBack () {
      let obj = {}
      if (this.isApprove) {
        obj = {
          1: '/management-system/bannerList',
          2: '/management-system/articleList',
          3: '/management-system/activityList'
        }
      } else {
        obj = {
          1: '/management-system/bannerApproveList',
          2: '/management-system/articleApproveList',
          3: '/management-system/activityApproveList'
        }
      }
      this.$router.replace(obj[this.sourceType])
    },
    handleChange (source) {
      const {raw: file} = source
      const isJPG = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
      if (!isJPG) {
        this.$message.error('上传头像图片只能是JPG/PNG/JPEG格式!')
        return false
      }
      this.cropperImg = URL.createObjectURL(file)
    },
    beforeUpload (file) {
      const isJPG = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
      if (!isJPG) {
        this.$message.error('上传头像图片只能是JPG/PNG/JPEG格式!')
        return false
      }
    },
    startCrop () { // 开始裁剪
      this.$refs.cropper.getCropBlob(async (blob) => {
        const file = new File([blob], 'img.jpg', {
          type: blob.type
        })
        const formData = new FormData()
        formData.append('file', file)
        formData.append('fileType', 'image')
        formData.append('sourceType', this.sourceType)
        const { data: imgUrl } = await uploadImage(formData)
        this.$set(this.ruleForm, 'imgUrl', imgUrl)
        this.$message({
          type: 'success',
          message: '图片上传成功'
        })
      })
    },
    fileUpdateEvent (res, file) {
      this.$set(this.ruleForm, 'contentImgUrl', file.response.data)
    },
    handleUploadSuccess (url) {
      // 富文本图片或视频
      this.fileUrls.push(url)
    },
    handleEditorChange (html) {
      this.$set(this.ruleForm, 'bannerContent', html)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    preView () {
      this.isPreview = !this.isPreview
    },
    async contentDetail () {
      let params = []
      if (this.sourceType === 1) {
        params = { bannerId: this.id }
      } else if (this.sourceType === 2) {
        params = { articleId: this.id }
      } else if (this.sourceType === 3) {
        params = { activityId: this.id }
      }
      const { data = {} } = await getConentDetail(this.detailUrl, params)

      if (this.sourceType === 3) {
        const { name: title, coverImageUrl: imgUrl, registrationStartTime, registrationEndTime, activityStartTime, activityEndTime, createNoticeType, startNoticeType } = data
        if (createNoticeType === 1 || createNoticeType === 2) {
          this.isNotice = 3
        } else {
          this.isNotice = 0
        }
        this.isRemind = startNoticeType ? 1 : 0

        Object.assign(this.ruleForm, {title, bannerContent: data[this.sourceKey], imgUrl, signUpTime: [new Date(registrationStartTime), new Date(registrationEndTime)], beginTime: [new Date(activityStartTime), new Date(activityEndTime)], createNoticeType, startNoticeType: !startNoticeType ? [] : startNoticeType.split(',')})
      } else {
        const { publishTime = '', title, imgUrl, articleAbstract } = data
        Object.assign(this.ruleForm, {title, articleAbstract, bannerContent: data[this.sourceKey], imgUrl, publishTime: publishTime && new Date(publishTime)})
      }
      this.ruleForm.contentImgUrl = data.contentImgUrl || ''
    },
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { publishTime, bannerContent, articleAbstract, signUpTime, beginTime, createNoticeType, startNoticeType, ...others } = this.ruleForm
          if (publishTime && moment(publishTime).format('YYYY-MM-DD HH:mm') < moment().format('YYYY-MM-DD HH:mm')) {
            this.$message.warning('自定义发布时间不能小于当前时间')
            return false
          }
          let params = { ...others }
          if (['publish'].includes(this.type) && [1, 2].includes(this.sourceType)) { // 立即发布
            params.ifPublishNow = this.ifPublishNow
          }
          if (this.isApprove && this.sourceType !== 3 && !this.ifPublishNow) { // 发布时间-自定义时间
            params.publishTime = publishTime ? moment(publishTime).format('YYYY-MM-DD HH:mm') : ''
          }
          if (this.sourceType === 2 && articleAbstract) { // 文章公告
            params.articleAbstract = articleAbstract
          }
          if (this.sourceType === 3) {
            const {title, imgUrl, contentImgUrl} = others
            params = {
              name: title,
              coverImageUrl: imgUrl,
              contentImgUrl,
              registrationStartTime: moment(signUpTime[0]).format('YYYY-MM-DD HH:mm'),
              registrationEndTime: moment(signUpTime[1]).format('YYYY-MM-DD HH:mm'),
              activityStartTime: moment(beginTime[0]).format('YYYY-MM-DD HH:mm'),
              activityEndTime: moment(beginTime[1]).format('YYYY-MM-DD HH:mm'),
              createNoticeType: this.isNotice === 3 ? createNoticeType : 0,
              startNoticeType: this.isRemind === 1 ? startNoticeType.join(',') : ''
            }
          }
          params.fileUrls = [...this.fileUrls, this.ruleForm.imgUrl, this.ruleForm.contentImgUrl]
          params[this.sourceKey] = bannerContent
          if (this.type === 'publish') { // 发布
            const operateFunctions = {
              1: bannerOperate,
              2: articleOperate,
              3: activityOperate
            }
            if (this.sourceType === 3) { // 活动
              if (moment().format('YYYY-MM-DD HH:mm') > moment(signUpTime[1]).format('YYYY-MM-DD HH:mm')) {
                this.$message.warning('活动发布时间不能大于活动报名结束时间')
                return false
              }
              params = {
                id: this.id,
                publishStatus: 1,
                createNoticeType: params.createNoticeType,
                startNoticeType: params.startNoticeType
              }
            } else {
              params = { // banner 文章
                id: this.id,
                publishStatus: 1,
                ifPublishNow: params.ifPublishNow,
                publishTime: params.publishTime
              }
            }
            await operateFunctions[this.sourceType](params)
          } else if (this.id) {
            await updateConfigInfo(this.updateUrl, {...params, id: this.id})
          } else {
            await saveConfigInfo(this.saveUrl, params)
          }
          this.$message({
            message: `${this.submitText}成功`,
            type: 'success'
          })
          this.goBack()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    closePrview () {
      this.isPreview = false
    }
  }
}
</script>

<style>
  .avatar-uploader-1 .el-upload, .avatar-uploader-2 .el-upload, .avatar-uploader-3 .el-upload, .content-img .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 2px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    font-size: 28px;
    line-height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .avatar-uploader-1 .el-upload {
    width: 400px;
    height: 192px;
  }
  .avatar-uploader-2 .el-upload {
    width: 400px;
    height: 142px;
  }
  .avatar-uploader-3 .el-upload {
    width: 400px;
    height: 170px;
  }
  .content-img .el-upload {
    width: 400px;
    height: 192px;
  }
  .rate {
    font-size: 13px;
    font-weight: 600;
    color: red;
  }
</style>

<style lang="scss" scoped>
  .deal-img {
    margin-bottom: 60px;
    .cropper-wrapper {
      width: 750px;
      height: 360px;
    }
    .avatar {
      width: 100%;
    }
  }
  .content-img {
    .avatar {
      width: 100%;
    }
  }
  .form-style {
    margin: 20px;
    height: 100%;
    background: #fff;
    padding: 30px 30px 120px 30px;
    overflow-y: auto;
  }
  .operate-btns {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
  }
  .ml30 {
    margin-left: 30px;
  }
</style>